import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails,
  DriverResponseDTO,
  GridRequestDto
} from '../../interfaces/apiInterfaces';

export class GetDriverCommand extends IRequestCommand<
  IGetDriverResponse,
  ErrorDetails,
  IGetDriversCommandParameters
> {

  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/drivers/paginated?page={page}&size={size}&column={column}&sort={sort}&states={states}&find={find}';

  constructor(dashboard: boolean = false) {
    super();

    this._commandUrl =
      (dashboard) ?
        'carriers/{carrierUserId}/drivers/dashboard?page={page}&size={size}&column={column}&sort={sort}&value={value}&states={states}&driverId={driverId}&vehicleIdSwitch={vehicleIdSwitch}'
        : this._commandUrl;
  }

  public override setParameters(parameters: IGetDriversCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );

    this._commandUrl = this._commandUrl.replace(
      '{page}',
      parameters.page.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      parameters.size.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      parameters.column.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      parameters.sort.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{states}',
      parameters.states.toString()
    );
    this._commandUrl = this._commandUrl.replace('{value}', parameters.value ? parameters.value : '');

    this._commandUrl = this._commandUrl.replace('{find}', parameters.find ? parameters.find : '');

    this._commandUrl = this._commandUrl.replace(
      '{driverId}',
      parameters.findDriverId ? parameters.findDriverId : ''
    );

    this._commandUrl = this._commandUrl.replace(
      '{vehicleIdSwitch}',
      parameters.vehicleIdSwitch ? String(parameters.vehicleIdSwitch) : 'false'
    );
  }
}

export interface IGetDriversCommandParameters
  extends ICommandParameters,
  GridRequestDto {
  states: string;
  vehicleIdSwitch?: boolean;
}

export interface IGetDriverResponse
  extends DriverResponseDTO,
  ICommandResponse { }
